import React from 'react'
import { ReactComponent as RedDiceSVG } from '../../../../../../lib/assets/redDice.svg'
import { DiceWrapper } from '../../../AutoConfigStyles'

export default function DoubleRedDice() {
  return (
    <DiceWrapper>
      <RedDiceSVG />
      <RedDiceSVG />
    </DiceWrapper>
  )
}
